import React, { lazy, useState } from 'react'
import { Col, Form, Modal, Row, Switch, message } from 'antd'
import { useContext } from 'react'

import './ProjectDetailsPanel.scss'
import { SelectField, AutoFieldComponent, DateField } from '../../components'
import {
  PLACEHOLDER_MESSAGES,
  VALIDATION_MESSAGES,
} from '../../utils/constants/messages'
import {
  zohoProjectIdRule,
  projectNameRule,
  retainerRule,
} from '../../utils/constants/validationRules'
import {
  afteFieldRetainerOptions,
  UserRoles,
} from '../../utils/constants/constant'
import { AuthContext } from '../../store/auth'
const AddonAfterField = lazy(() => import('../AddonAfterField/AddonAfterField'))

const ProjectDetailsPanel = ({
  projectData,
  form,
  isShowFields,
  accTypeOptions,
  onDateChange,
  prjStartDate,
  isMultiModelToggleDisabled,
}) => {
  const [showWarningModal, setShowWarningModal] = useState(false)
  const [isEnableNotification, setIsEnableNotification] = useState(
    projectData?.enableInvoiceOverdueNotification
  )
  const { userRole } = useContext(AuthContext)

  const normalizeSingleActiveBillingConfig = (configs = []) => {
    let activeModelSelected = false

    return configs.map((config) => {
      if (config?.active !== false && !activeModelSelected) {
        activeModelSelected = true
        return { ...config, active: true }
      }

      return { ...config, active: false }
    })
  }

  return (
    <Row gutter={20}>
      <Col lg={12} md={12} sm={12}>
        <AutoFieldComponent
          name="zohoProjectId"
          label="Zoho Project ID"
          placeholder={PLACEHOLDER_MESSAGES.zohoProjectIdMessage}
          existingValue={projectData?.zohoProjectId}
          type="text"
          required
          value={projectData?.zohoProjectId}
          disabled={true}
          rules={zohoProjectIdRule}
        />
      </Col>
      <Col lg={12} md={12} sm={12}>
        <AutoFieldComponent
          name="projectName"
          label="Project Name"
          placeholder={PLACEHOLDER_MESSAGES.projectNameMessage}
          existingValue={projectData?.name}
          type="text"
          disabled={true}
          required
          rules={projectNameRule}
        />
      </Col>
      {isShowFields.retainer && (
        <>
          <Col lg={12} md={12} sm={12}>
            <AddonAfterField
              name="retainer"
              label="Retainer"
              required={true}
              afteFieldOptions={afteFieldRetainerOptions}
              defaultAfterFieldValue={
                projectData?.tmHours === null || projectData?.tmHours === true
              }
              initialValue={projectData?.retainer || null}
              rules={retainerRule}
              onChange={(value) => {
                form.setFields([
                  {
                    name: 'tmHours',
                    value: value,
                    touched: true,
                  },
                ])
                form.validateFields(['tmHours'])
              }}
              afterFieldName={'tmHours'}
              form={form}
            />
          </Col>
        </>
      )}
      <Col lg={12} md={12} sm={12}>
        <SelectField
          name="accType"
          label="Acc Type"
          options={accTypeOptions}
          existingValue={
            projectData?.accType === '-' ? null : projectData?.accType
          }
          placeholder={PLACEHOLDER_MESSAGES.accountTypeMessage}
          type="text"
          required
          rules={[
            {
              required: true,
              message: VALIDATION_MESSAGES.accountTypeMessage,
            },
          ]}
        />
      </Col>
      <Col lg={12} md={12} sm={12}>
        <DateField
          onDateChange={onDateChange}
          name="projectStartDate"
          label="Project Start Date"
          type="text"
          placeholder={PLACEHOLDER_MESSAGES.projectStartDateMessage}
          existingValue={projectData?.projectStartDate}
          valuePropName={'date'}
          value={prjStartDate}
          required
          rules={[
            {
              required: true,
              message: VALIDATION_MESSAGES.projectStartDateMessage,
            },
          ]}
        />
      </Col>
      <Col lg={12} md={12} sm={12}>
        <Form.Item
          label={'Invoice Overdue  Email Notification'}
          name={'enableInvoiceOverdueNotification'}
          initialValue={projectData?.enableInvoiceOverdueNotification}
        >
          <Switch
            checkedChildren={'Enable'}
            unCheckedChildren={'Disable'}
            onChange={() => setShowWarningModal(true)}
            checked={isEnableNotification}
          />
        </Form.Item>
      </Col>
      {userRole === UserRoles.ADMIN && (
        <Col lg={12} md={12} sm={12}>
          <Form.Item
            label={'Allow Multi Model'}
            name={'isMultiModelEnabled'}
            initialValue={projectData?.isMultiModelEnabled}
            valuePropName="checked"
          >
            <Switch
              checkedChildren={'Enable'}
              unCheckedChildren={'Disable'}
              onChange={(value) => {
                form.setFields([
                  {
                    name: ['isMultiModelEnabled'],
                    errors: [],
                  },
                ])

                if (!value) {
                  const billingConfigs =
                    form.getFieldValue('projectConfigurationDetails') || []
                  const activeBillingCount = billingConfigs.filter(
                    (config) => config?.active !== false
                  ).length

                  if (activeBillingCount > 1) {
                    form.setFieldValue(
                      'projectConfigurationDetails',
                      normalizeSingleActiveBillingConfig(billingConfigs)
                    )
                    message.info(VALIDATION_MESSAGES.multiModelAutoFixMessage)
                  }
                }

                form.validateFields([
                  'isMultiModelEnabled',
                  'projectConfigurationDetails',
                ])
              }}
              disabled={isMultiModelToggleDisabled}
            />
          </Form.Item>
        </Col>
      )}
      {/* 
          <Col lg={12} md={12} sm={12}>
            <InputField
              name="retainerActiveBalance"
              label="Active Balance"
              placeholder={PLACEHOLDER_MESSAGES.activeBalanceMessage}
              existingValue={projectData?.retainerActiveBalance}
              type="text"
              rules={activeBalanceRule}
            />
          </Col>
          <Col lg={12} md={12} sm={12}>
            <DateField
              name="retainerActiveDate"
              label="Active Balance Date"
              type="text"
              placeholder={PLACEHOLDER_MESSAGES.activeBalanceDateMessage}
              existingValue={projectData?.retainerActiveDate}
              rules={activeBalanceDateRule(
                form.getFieldValue('retainerActiveBalance')
              )}
            />
          </Col>
        </>
      )} */}
      <Modal
        title={`Do you want to ${
          isEnableNotification ? 'disable' : 'enable'
        } invoice overdue notification ?`}
        open={showWarningModal}
        onOk={() => {
          setIsEnableNotification(!isEnableNotification)
          setShowWarningModal(false)
        }}
        onCancel={() => {
          setShowWarningModal(false)
        }}
        okText="Yes"
        cancelText="No"
        bodyStyle={{ display: 'none' }}
      />
    </Row>
  )
}

export default ProjectDetailsPanel
